import React from 'react';
import { Card, Button, Empty, Space, Typography, Alert, Row, Col } from 'antd';
import { InfoCircleOutlined, ArrowRightOutlined, LockOutlined } from '@ant-design/icons';
import PageHeader from '../../components/shared/PageHeader';
import PricingSection from '../../components/PricingTable/pricingTable';
import { getSubscriptions } from '../../api/subscription';

const { Title, Text, Paragraph } = Typography;

const NotSubscribedPage = ({ user }) => {
    const [subscriptions, setSubscriptions] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                setLoading(true);
                const response = await getSubscriptions();
                setSubscriptions(response.results);
            } catch (error) {
                console.error('Error fetching subscriptions:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSubscriptions();
    }, []);

    return (
        <main className="min-h-full flex flex-col gap-6">

            <div className="flex-grow bg-white ml-6 p-6 flex flex-col gap-6">
                <Alert
                    message="Subscription Required"
                    description="Your account currently doesn't have an active subscription. Please choose a plan to continue."
                    type="warning"
                    showIcon
                    className="mb-4"
                />


                <div id="pricing-section">
                    {loading ? (
                        <Card>
                            <div className="py-12 flex justify-center">
                                <div className="w-32 h-32 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
                            </div>
                        </Card>
                    ) : subscriptions.length > 0 ? (
                        <PricingSection pricingPlans={subscriptions} />
                    ) : (
                        <Card>
                            <Empty
                                description="No subscription plans available at the moment."
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                            >
                                <Button type="primary">Contact Support</Button>
                            </Empty>
                        </Card>
                    )}
                </div>
            </div>
        </main>
    );
};

export default NotSubscribedPage;